import React, { useState } from "react";
import Courses1 from "../../../Assets/Homeimgs/top-MERN-Stack.webp";
import Courses2 from "../../../Assets/Homeimgs/Courses2.png";
import Courses3 from "../../../Assets/Homeimgs/Courses3.png";
import Courses4 from "../../../Assets/Homeimgs/Courses4.png";
import Courses5 from "../../../Assets/Homeimgs/Courses5.png";
import Courses6 from "../../../Assets/Homeimgs/Courses6.png";

import webDev from "../../../Assets/Services/webDev.png";
import appDev from "../../../Assets/Services/AppDev.png";
import dataAnalyst from "../../../Assets/Services/DataAnalyst.png";
import ML from "../../../Assets/Services/ML.png";
import DSA from "../../../Assets/Services/DSA.png";
import UI from "../../../Assets/Services/UI.png";

import FrontendProjects from "../../../Assets/Services/Frontend _Project.png";
import fullStack from "../../../Assets/Services/Full_stack_Project.png";
import applicationProject from "../../../Assets/Services/Application_Projects.png";
import IOT from "../../../Assets/Services/IOT.png";
import AI from "../../../Assets/Services/AI_Project.png";

import FaqSectionService from "../../userComponents/CoursesComponents/FaqSectionService";
import CourseCard from "../../userComponents/CoursesComponents/CourseCard";
import InternShipCards from "../../userComponents/CoursesComponents/InternShipCards";
import ProjectCards from "../../userComponents/CoursesComponents/ProjectCard";
import TechSlider from "../Common/TechSlider";
import { useNavigate } from "react-router-dom";

const courses = [
  {
    image: Courses1,
    title: "Full-Stack Web Development In MERN",
    price: 16000,
    originalPrice: 20000.0,
    lessons: "30+",
    assignments: "15+",
    duration: "10k Enrolled",
    rating: 4.6,
    reviews: 48,
  },
  {
    image: Courses2,
    title: "Full-Stack Web Development In Python",
    price: 10000,
    originalPrice: 14000.0,
    lessons: "30+",
    assignments: "15+",
    duration: "10k Enrolled",
    rating: 4.0,
    reviews: 15,
  },
  {
    image: Courses3,
    title: "Full-Stack Java",
    price: 8000,
    originalPrice: 12500.0,
    lessons: "30+",
    assignments: "15+",
    duration: "10k Enrolled",
    rating: 4.0,
    reviews: 15,
  },
  {
    image: Courses4,
    title: "AI/ML Beginners to Advance",
    price: 10000,
    originalPrice: 15000.0,
    lessons: "30+",
    assignments: "15+",
    duration: "10k Enrolled",
    rating: 4.0,
    reviews: 15,
  },
  {
    image: Courses5,
    title: "DSA Full Course",
    price: 4500,
    originalPrice: 70000.0,
    lessons: "30+",
    assignments: "15+",
    duration: "10k Enrolled",
    rating: 4.0,
    reviews: 15,
  },
  {
    image: Courses6,
    title: "User Experience Design",
    price: 8500,
    originalPrice: 10000.0,
    lessons: "30+",
    assignments: "15+",
    duration: "10k Enrolled",
    rating: 4.0,
    reviews: 15,
  },
];

const internShips = [
  {
    projectName: "Web Development",
    description:
      "Work on real-world front-end, back-end, and database projects, including APIs and version control systems.",
    rating: 4.0,
    numberOfReviews: 15,
    img: webDev,
  },
  {
    projectName: "App Development",
    description:
      "Build mobile and web applications with modern frameworks, APIs, and performance-optimized architectures.",
    rating: 4.0,
    numberOfReviews: 15,
    img: appDev,
  },
  {
    projectName: "Data Analytics",
    description:
      "Analyze real datasets, create dashboards, and extract insights to support data-driven decisions.",
    rating: 4.0,
    numberOfReviews: 15,
    img: dataAnalyst,
  },
  {
    projectName: "Machine Learning with Real-life Dataset",
    description:
      "Implement ML models, tune hyperparameters, and deploy solutions using real industry-style datasets.",
    rating: 4.0,
    numberOfReviews: 15,
    img: ML,
  },
  {
    projectName: "DSA Full Course",
    description:
      "Master core data structures, algorithms, and problem-solving skills required for top tech interviews.",
    rating: 4.0,
    numberOfReviews: 15,
    img: DSA,
  },
  {
    projectName: "User Experience Design",
    description:
      "Design intuitive user journeys, wireframes, and prototypes using industry-standard design tools.",
    rating: 4.0,
    numberOfReviews: 15,
    img: UI,
  },
];

const projects = [
  {
    projectName: "Frontend Project",
    projectImage: FrontendProjects,
  },
  {
    projectName: "Full Stack Project",
    projectImage: fullStack,
  },
  {
    projectName: "Application Project",
    projectImage: applicationProject,
  },
  {
    projectName: "IOT Project",
    projectImage: IOT,
  },
  {
    projectName: "AI Project",
    projectImage: AI,
  },
];

const ContentSection = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  const tabs = [
    { label: "Top Notch Courses", icon: "💻" },
    { label: "Part / Full Time Internships", icon: "🛠️" },
    { label: "Live Projects", icon: "🚀" },
  ];

  const CourseFAQs = [
    {
      id: "faqA",
      question:
        "What will I learn in the Full-Stack Web Development in MERN course?",
      answer:
        "The MERN stack course covers MongoDB, Express.js, React, and Node.js. You’ll learn to build full-stack applications with RESTful APIs, authentication, and deployment.",
    },
    {
      id: "faq1",
      question:
        "What are the prerequisites for Full-Stack Web Development in Python?",
      answer:
        "Basic Python knowledge is recommended. The course includes Django or Flask, frontend skills, database management, and deployment strategies.",
    },
    {
      id: "faq2",
      question: "What does the Full-Stack Java course entail?",
      answer:
        "You’ll learn Spring Boot for backend, JavaScript for frontend, and databases to build robust, scalable web apps.",
    },
    {
      id: "faq3",
      question:
        "What can I expect from the AI/ML Beginners to Advanced course?",
      answer:
        "You’ll cover AI/ML fundamentals, supervised and unsupervised learning, neural networks, deep learning, and real-world projects.",
    },
    {
      id: "faq4",
      question: "What topics are covered in the DSA Full Course?",
      answer:
        "Core data structures, algorithms, and problem-solving patterns to prepare you for coding interviews.",
    },
    {
      id: "faq5",
      question:
        "What skills will I gain from the User Experience (UX) Design course?",
      answer:
        "User-centered design, wireframing, prototyping, usability testing, and hands-on work with design tools.",
    },
  ];

  const InternShipfaqs = [
    {
      id: "faqA",
      question: "Who is eligible to apply for the internship?",
      answer:
        "Typically candidates enrolled in or having completed one of our courses. Requirements may vary per role.",
    },
    {
      id: "faq1",
      question: "What will I work on as an intern?",
      answer:
        "You’ll work on real-world tasks like development, research, testing, or content based on your domain.",
    },
    {
      id: "faq2",
      question: "How will I be evaluated during my internship?",
      answer:
        "Evaluations are based on contributions, punctuality, skill application, learning attitude, and ownership.",
    },
    {
      id: "faq3",
      question: "What is the duration of the internship program?",
      answer:
        "Most programs run between 3 to 6 months, depending on the role and project needs.",
    },
    {
      id: "faq4",
      question: "Do I get mentorship during my internship?",
      answer:
        "Yes, you’ll work with mentors or supervisors who guide you through tasks and career growth.",
    },
    {
      id: "faq5",
      question: "Can I convert this internship into a full-time role?",
      answer:
        "High performers may be offered full-time opportunities, subject to role availability.",
    },
  ];

  const ProjectFAQs = [
    {
      id: "faqA",
      question: "Can I work on multiple projects at the same time?",
      answer:
        "You can, but focusing on one project at a time usually gives better depth and learning outcomes.",
    },
    {
      id: "faq1",
      question: "What skills do I need to work on a Frontend Project?",
      answer:
        "HTML, CSS, JavaScript, and ideally a framework like React plus responsive design basics.",
    },
    {
      id: "faq2",
      question: "What does a Full Stack Project involve?",
      answer:
        "Working on both frontend and backend plus database integration to build a complete application.",
    },
    {
      id: "faq3",
      question: "What kind of tasks are involved in an Application Project?",
      answer:
        "UI/UX, API integration, performance optimization, testing, and deployment for mobile or web apps.",
    },
    {
      id: "faq4",
      question: "What skills are required for an IoT Project?",
      answer:
        "Embedded systems, sensors, protocols (MQTT/HTTP), and programming in C/C++/Python with microcontrollers.",
    },
    {
      id: "faq5",
      question: "What does an AI Project entail?",
      answer:
        "Designing and training models, data preprocessing, evaluation, and using frameworks like TensorFlow or PyTorch.",
    },
  ];

  let faqs;
  if (activeTab === 0) faqs = [...CourseFAQs];
  else if (activeTab === 1) faqs = [...InternShipfaqs];
  else faqs = [...ProjectFAQs];

  return (
    <section>
      <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-10 lg:py-16">
        {/* Background glow */}
        <div className="pointer-events-none absolute inset-0 opacity-40">
          <div className="absolute -left-24 top-0 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
          <div className="absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
        </div>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* Section Heading */}
          <div className="text-center mb-8 md:mb-10" data-aos="fade-up">
            <p className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-white/5 border border-white/10 text-xs sm:text-sm text-[#5989C8] font-medium backdrop-blur-md">
              Learn • Build • Grow
            </p>
            <h2 className="mt-4 text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-wide">
              Courses, Internships & Live Projects
            </h2>
            <p className="mt-3 text-sm md:text-base text-slate-300/90 max-w-2xl mx-auto">
              Choose from top-notch courses, real-world internships, and
              industry-focused live projects to accelerate your learning
              journey.
            </p>
          </div>

          {/* Tabs */}
          <div className="flex justify-center mb-6 md:mb-8">
            <div className="inline-flex items-center rounded-full bg-white/5 border border-white/10 backdrop-blur-md px-2 py-1 sm:px-3 sm:py-2">
              {tabs.map((tab, index) => {
                const isActive = activeTab === index;
                return (
                  <button
                    key={index}
                    onClick={() => setActiveTab(index)}
                    className={`relative mx-1 flex items-center gap-1 sm:gap-2 rounded-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium transition-all duration-200 ${
                      isActive
                        ? "bg-[#064585] text-white shadow-lg shadow-[#064585]/40"
                        : "text-slate-300 hover:text-white hover:bg-white/10"
                    }`}
                  >
                    <span className="text-base sm:text-lg">{tab.icon}</span>
                    <span className="hidden sm:inline-block">{tab.label}</span>
                    <span className="sm:hidden">{tab.label.split(" ")[0]}</span>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-10">
            {activeTab === 0 &&
              courses.map((course, index) => (
                <CourseCard key={index} course={course} navigate={navigate} />
              ))}

            {activeTab === 1 &&
              internShips.map((internship, index) => (
                <InternShipCards key={index} internship={internship} />
              ))}

            {activeTab === 2 &&
              projects.map((project, index) => (
                <ProjectCards key={index} project={project} />
              ))}
          </div>

          {/* FAQ Section */}
        </div>
      </section>
      <TechSlider />
      <FaqSectionService faqs={faqs} />
    </section>
  );
};

export default ContentSection;
